import React, { FC, useCallback, useContext, useEffect, useState } from 'react'
import { Box, Grid } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { toast } from 'react-toastify'
import { GetUserProfileResponseDto } from '@sparling/financial-common'
import { General } from './General'
import { UserInfo } from './UserInfo'
import { Security } from './Security'
import { KYCStatus } from './KYCStatus'
import { LoginHistory } from './LoginHistory'
import { CompanyUsers } from './CompanyUsers'
import { AppStateContext, useRest } from '../../../components/Context'
import { GridRow } from '../../../components/GridRow'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  withoutTitle: {
    paddingTop: 40,
  },
}))

export const Account: FC = () => {
  const classes = useStyles()
  const { rxiosAuth } = useRest()
  const { getUserRole } = useContext(AppStateContext)
  const [userRole, setUserRole] = useState<string>()
  const [userAccount, setUserAccount] = useState<null | GetUserProfileResponseDto>(null)
  const [loadingUserData, setLoadingUserData] = useState<boolean>(true)

  useEffect(() => setUserRole(getUserRole()), [setUserRole, getUserRole])

  const loadData = useCallback(async () => {
    setLoadingUserData(true)

    rxiosAuth.get('user-profile').subscribe(
      // eslint-disable-next-line
      (next: any) => {
        setUserAccount(next)
        // console.log(next)
        setLoadingUserData(false)
      },
      (error) => {
        toast.error(error)
        setLoadingUserData(true)
      },
    )
  }, [rxiosAuth])

  useEffect(() => {
    ;(async () => {
      await loadData()
    })()
    // eslint-disable-next-line
  }, [])

  return (
    <Box className={classes.container}>
      <GridRow spacing={4}>
        <Grid item xs={6} className={classes.withoutTitle}>
          <General loading={loadingUserData} userAccount={userAccount} refresh={loadData} />
        </Grid>
        <Grid item xs={6}>
          <UserInfo title={'User Info'} loading={loadingUserData} userAccount={userAccount} />
        </Grid>
      </GridRow>

      <GridRow spacing={4}>
        <Grid item xs={6}>
          <Security title={'Security'} />
        </Grid>
        <Grid item xs={6}>
          <KYCStatus title={'KYC Status'} />
        </Grid>
      </GridRow>

      <GridRow spacing={4}>
        <Grid item xs={6}>
          <LoginHistory title={'Login History'} />
        </Grid>
        {userRole && userRole !== 'sole_trader' && (
          <Grid item xs={6}>
            <CompanyUsers title={'Company Users'} />
          </Grid>
        )}
      </GridRow>
    </Box>
  )
}
